/**
 * VSPC UI API
 * Internal API
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum EVacAgentStatusInteg {
    Healthy = 'healthy',
    Inacessible = 'inacessible',
    NotInstalled = 'notInstalled',
    Warning = 'warning',
    Updating = 'updating',
    Error = 'error',
    Restarting = 'restarting',
    Installation = 'installation',
    FailedToUpdate = 'failedToUpdate',
    Applying = 'applying',
    Rejected = 'rejected',
    NotManaged = 'notManaged',
    NotSet = 'notSet'
};

